//External
import React, { useEffect } from "react";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
import { getFadeFlag } from "utils";

/*******************
  @Purpose : used for fancy box
  @Parameter : {props}
  @Author : INIC
  *******************/
function Fancybox(props) {
  const delegate = props.delegate || "[data-fancybox]";

  /*******************
  @Purpose : React Hook used for native fancy box
  @Parameter : {}
  @Author : INIC
  *******************/
  useEffect(() => {
    let oldIndex = 0;
    const opts = props.options || {};

    NativeFancybox.bind(delegate, {
      ...opts,
      on: {
        ready: (fancybox, slide) => {
          if (getFadeFlag()) {
            oldIndex = props.handleSliderIndex();
            fancybox.jumpTo(oldIndex);
          }
        },
        destroy: (fancybox, slide) => {
          if (getFadeFlag()) {
            props.handleSliderReset(oldIndex);
          }
        },
      },
    });

    return () => {
      NativeFancybox.destroy();
    };
  }, []);

  /*******************
	@purpose : Render HTML/ React Components
	@Author : INIC
	******************/
  return <>{props.children}</>;
}

export default Fancybox;
